import React from 'react';
import './PlayButton.scss';
import PlayArrow from '../../Icons/PlayArrow';

/**
 * Render a button with play arrow icon
 * @param text - Text that goes in the button
 * @param additionalClasses - Additional classes to include on the button
 * @param textClasses - Additional classes to include in the text of the button
 * @param onClick - Event to trigger when button is clicked
 * @returns {JSX.Element}
 * @constructor
 */
const PlayButton = ({ text, additionalClasses, textClasses, onClick }) => {
  return (
    <button className={`c-play-button ${additionalClasses}`} onClick={onClick}>
      <PlayArrow />
      <div className={`c-play-button__text cta text-cta ${textClasses}`}>{text}</div>
    </button>
  );
};

export default PlayButton;
